import { FC, useState } from 'react';
import * as Switch from '@radix-ui/react-switch';
import classNames from 'classnames';

import { useFallbackTranslation } from '@gn-audio/jss-components';

import { SoundDemoClipComponentProps } from 'components/Product/SoundDemo/soundDemoTypes';

export const SoundDemoClipSwitch: FC<SoundDemoClipComponentProps> = ({
  SoundDemoEnvironment,
  setSelectedDemoClip,
  theme,
}) => {
  const { t } = useFallbackTranslation();
  const [demoClipSwitched, setDemoClipSwitched] = useState<boolean>(false);

  const darkTheme = 'bg-black shadow-black';
  const lightTheme = 'bg-gray-200 shadow-[inset_0px_2px_2px_0px_rgba(0,0,0,0.25)]';
  const themeClass = theme === 'light' ? lightTheme : darkTheme;

  const setDemoClip = (isDemoClipSwitched: boolean) => {
    setDemoClipSwitched(isDemoClipSwitched);
    setSelectedDemoClip(
      isDemoClipSwitched
        ? SoundDemoEnvironment.SoundDemoClips[1].SoundDemoName?.value
        : SoundDemoEnvironment.SoundDemoClips[0].SoundDemoName?.value
    );
  };

  return (
    <div className="flex items-center justify-center gap-6">
      <label id={`clip-label-left-${SoundDemoEnvironment.id}`} className="text-base">
        {SoundDemoEnvironment.SoundDemoClips[0].SoundDemoName?.value}
      </label>
      <Switch.Root
        checked={demoClipSwitched}
        aria-label={t('system.TryTheFeatures')}
        aria-describedby={
          demoClipSwitched
            ? `clip-label-right-${SoundDemoEnvironment.id}`
            : `clip-label-left-${SoundDemoEnvironment.id}`
        }
        id={`clip-switch-${SoundDemoEnvironment.id}`}
        onCheckedChange={(isDemoClipSwitched) => setDemoClip(isDemoClipSwitched)}
        className={classNames(
          themeClass,
          'relative h-8 w-24 cursor-default rounded-full outline-none focus-visible:outline-focus'
        )}
      >
        <Switch.Thumb className="block h-6 w-12 translate-x-0.5 cursor-pointer rounded-full bg-primary shadow-[0_2px_2px] shadow-black/30 transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-11" />
      </Switch.Root>
      <label id={`clip-label-right-${SoundDemoEnvironment.id}`} className="text-base">
        {SoundDemoEnvironment.SoundDemoClips[1].SoundDemoName?.value}
      </label>
    </div>
  );
};
